<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    华侨城站<br>
站点介绍<br>
华侨城站是个岛式站台。车站装修以白色为主，空间简洁明快，利用简单的材料组合及LED灯具的特性，创造出现代简洁的地下空间。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:03	23:40	1号线	2分钟	4分40秒<br>
机场东	06:02	23:28	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:30	23:39	1号线	3分45秒	5分45秒<br>
机场东	06:18	23:27	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:30	00:39	1号线	3分45秒	5分45秒<br>
机场东	06:18	00:27	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
深南大道北侧（东）、深圳海景嘉途酒店、黄金海岸<br><br>
B出入口:<br>
侨城东街、华侨城、华侨城中学、华夏艺术中心、汉唐大厦、深南大道北（西）<br><br>
C出入口:<br>
何香凝美术馆、华·美术馆、深南大道南侧（西）<br><br>
D出入口:<br>
中国民俗文化村、深南大道南侧（东）、锦绣中华<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 华侨城地铁站<br>
433、M487、101、323、324、328<br><br>
C出入口:<br>
公交站名： 华侨城地铁站<br>
323、324、328、433、M487<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>







